import { Component } from '@angular/core';
import { OrderSummaryComponent } from '@spartacus/cart/base/components';
import { Observable } from "rxjs";
import { PermissionCheckService } from "../../../user-profiles/service/permission-check.service";
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-order-summary',
    templateUrl: './efa-order-summary.component.html',
    imports: [AsyncPipe, TranslatePipe]
})
export class EfaOrderSummaryComponent extends OrderSummaryComponent {

  constructor(protected permissionCheckService: PermissionCheckService) {
    super();
  }

  displayCustomerPrices$: Observable<boolean> = this.permissionCheckService.displayCustomerPrices();

}
